export { default } from './GlobalIncidents';
